var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarInactive = function SvgCalendarInactive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 23 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M7.834 1.834v2.75M15.167 1.834v2.75M3.709 8.333h15.583M19.75 7.792v7.792c0 2.75-1.375 4.583-4.583 4.583H7.833c-3.208 0-4.583-1.834-4.583-4.584V7.793c0-2.75 1.375-4.583 4.583-4.583h7.334c3.208 0 4.583 1.833 4.583 4.583"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#A8A8A8",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9 14 2 2 4-4"
  })));
};
export default SvgCalendarInactive;